import React, { createContext, useContext, useMemo } from "react";

const CurrencyContext = createContext({
  currency: "EUR",
  locale: "de-DE",
  formatMoney: (value, currency = "EUR") => new Intl.NumberFormat("de-DE", { style: "currency", currency }).format(Number(value || 0)),
});

export const resolveOrgCurrency = (company = {}) => {
  const configured = String(company.base_currency || "").toUpperCase();
  if (configured === "CHF" || configured === "EUR") return configured;
  const country = String(company.main_country || company.land || "").trim().toUpperCase();
  return ["CH", "SCHWEIZ", "SWITZERLAND"].includes(country) ? "CHF" : "EUR";
};

export const resolveOrgLocale = (company = {}) => {
  if (company.locale) return company.locale;
  return resolveOrgCurrency(company) === "CHF" ? "de-CH" : "de-DE";
};

export const formatMoney = (value, currency = "EUR", locale) => {
  const code = String(currency || "EUR").toUpperCase();
  const effectiveLocale = locale || (code === "CHF" ? "de-CH" : "de-DE");
  try {
    return new Intl.NumberFormat(effectiveLocale, { style: "currency", currency: code }).format(Number(value || 0));
  } catch {
    return `${Number(value || 0).toLocaleString(effectiveLocale)} ${code}`;
  }
};

export function CurrencyProvider({ company, children }) {
  const baseCurrency = company?.base_currency;
  const land = company?.land;
  const localeSetting = company?.locale;
  const mainCountry = company?.main_country;
  const value = useMemo(() => {
    const profile = { base_currency: baseCurrency, land, locale: localeSetting, main_country: mainCountry };
    const currency = resolveOrgCurrency(profile);
    const locale = resolveOrgLocale(profile);
    return {
      currency,
      locale,
      formatMoney: (amount, documentCurrency = currency) => formatMoney(amount, documentCurrency, documentCurrency === currency ? locale : undefined),
    };
  }, [baseCurrency, land, localeSetting, mainCountry]);
  return <CurrencyContext.Provider value={value}>{children}</CurrencyContext.Provider>;
}

export const useOrgCurrency = () => useContext(CurrencyContext);
